import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchHackInfo = async () => {
    const {data} = await internalApi.get(`logs/hack/hackInfo`);
    return data.hackInfo;
}

export const useHackInfo = () => {
    return useQueryBase('hackInfo', fetchHackInfo);
}
const saveHackInfo = async ({diamond, energy}) => {
    return await internalApi.post(`logs/hack/modify`, {diamond, energy});
}

export const useSaveHackInfo = () => {
    return useMutationBase('hackInfo', saveHackInfo);
}

const fetchHackList = async (url) => {
    const {data} = await internalApi.get(url);
    return data;
}

export const useHackList = (url) => {
    return useQueryBase(['hackList', url], () => fetchHackList(url));
}

const deleteHack = async (seq) => {
    return await internalApi.delete(`logs/hack/${seq}`);
}

export const useDeleteHack = () => {
    return useMutationBase('hackList', deleteHack);
}

const fetchMonitoringIp = async () => {
    const {data} = await internalApi.get(`logs/monitoring-ip`);
    return data.ipList;
}

export const useMonitoringIp = () => {
    return useQueryBase('monitoringIp', fetchMonitoringIp);
}

const saveMonitoringIp = async (ip) => {
    return await internalApi.post(`logs/monitoring-ip`, {ip});
}

export const useSaveMonitoringIp = () => {
    return useMutationBase('monitoringIp', saveMonitoringIp);
}

const deleteMonitoringIpLog = async (pid) => {
    return await internalApi.delete(`logs/monitoring-ip-log/${pid}`);
}

export const useDeleteMonitoringIpLog = () => {
    return useMutationBase('monitoringIpLog', deleteMonitoringIpLog);
}

const deleteMonitoringIp = async (ip) => {
    return await internalApi.delete(`logs/monitoring-ip/${encodeURIComponent(ip)}`);
}

export const useDeleteMonitoringIp = () => {
    return useMutationBase('monitoringIp', deleteMonitoringIp);
}

const fetchMonitoringIpLog = async () => {
    const {data} = await internalApi.get(`logs/monitoring-ip-log`);
    return data;
}

export const useMonitoringIpLog = () => {
    return useQueryBase(['monitoringIpLog'], fetchMonitoringIpLog);
}
